import React from 'react';
import { COLOR } from '@latitude/core/utils/constants';
import { Svg } from './Chevron.styles';
const Chevron = _ref => {
  let {
    ariaHidden = false,
    color = COLOR.BLACK,
    direction = 'up'
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": `arrow ${direction} icon`,
    "aria-hidden": ariaHidden
  }, /*#__PURE__*/React.createElement(Svg, {
    color: color,
    direction: direction
  }));
};
export default Chevron;